<template>

<com-item name="player.overview" :size="size" :is-overview="3" :loading="loading" :is-empty="!active" title="Overview">

	<template v-slot:about>

		<p>Summary of {{ your }} plays with {{ playername }}.</p>

	</template>

	<template v-slot:stats>

		<com-overview label="First Play" type="date" :value="data.dateFirst" />

		<com-overview label="Last Play" type="date" :value="data.dateLast" />

		<com-overview label="Plays per Game" type="number" :value="data.perGame" />

		<com-overview label="1:1 Plays" type="number" :value="data.h2hPlays" />

		<com-overview label="Hours Played" type="number" :value="data.totalDuration" />

		<com-overview label="Group Combos" type="number" :value="data.groups" />

		<com-overview label="Overall Win Rate" type="percent" :value="data.winRatio" />

		<com-overview label="1:1 Win Rate" type="percent" :value="data.h2hRatio" v-if="data.h2hRatio !== false" />
		<com-overview label="1:1 Win Rate" type="number" :empty="true" v-if="data.h2hRatio === false" />

		<com-overview label="Group Win Rate" type="percent" :value="data.groupRatio" v-if="data.groupRatio !== false" />
		<com-overview label="Group Win Rate" type="number" :empty="true" v-if="data.groupRatio === false" />

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size', 'period'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		playername: function() {

			var name = this.player.name
			return name.split(' ')[0]

		},

		player: function() {

			return this.$store.getters['page/insights/player/player']

		},

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/player/overview']

		},

		active: function() {

			return this.data && !this.loading

		},

		isYearly: function() {

			return this.period !== 'all'

		}

	}

}

</script>

<style scoped>

</style>